
<template>
  <div style="display:inline-block">
    <Button icon="md-document" @click="openModal">{{value==''?'选择模版':value|fileName}}</Button>
    <Modal
        v-model="modal"
        title="选择模版"
        width="600"
        @on-cancel="cancel">
        <RadioGroup :value="value" @on-change="fileChange" style="display:block">
        <Row :gutter="10">
          <Col span="6">
              <Upload
                ref="upload"
                :show-upload-list="false"
                :default-file-list="uploadList"
                :on-success="handleSuccess"
                :format="['doc', 'docx']"
                :max-size="2048"
                :headers="uploadHeaders"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                :before-upload="handleBeforeUpload"
                type="drag"
                :action="uploadApiPath"
                >
                 <div style="height:150px;text-align:center;padding-top:15px">
                   <Icon type="md-add" style="color:#999" size="90"/>
                   <div style="font-size:12px;color:#999">上传模版</div>
                   <div style="font-size:11px;color:#ccc">相同文件名直接覆盖</div>
                 </div>
              </Upload>
          </Col>
          <Col span="18" v-if="msg!=''">
            <div style="height:150px;text-align:center;line-height:150px;color:#999">
              {{msg}}
            </div>
          </Col>
          <Col span="6" v-for="(file, ind) in files" :key="ind">
            <label>
              <Card style="width:100%;height:150px;text-align:center;">
                <Icon type="md-document" style="color:#666" size="90"/>
              </Card>
              <Radio :label="file" style="font-size:12px;color:#999"><span>{{file | fileName}}</span></Radio>
            </label>
          </Col>
        </Row>
      </RadioGroup>
    </Modal>
  </div>
</template>

<script>
import {fetch} from '../fetch/api'

export default {
  name: 'BidingTemplate',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    let token = localStorage.getItem('token')

    return {
      modal: false,
      files: [],
      msg: '',
      path: '',
      uploadList: [],
      uploadApiPath: '/api/biding/template',
      token: token,
      uploadHeaders: {
        'Authorization': `Bearer ${token}`
      }
    }
  },
  watch: {
  },
  components: {
  },
  filters: {
    fileName (file) {
      if (file === '') return ''
      let f = file.split('/')
      let l = f.length
      return f[l - 1]
    }
  },
  mounted () {

  },
  methods: {
    cancel () {
      this.$emit('input', '')
    },
    fileChange (val) {
      this.$emit('input', val)
    },
    openModal () {
      this.modal = true
      this.fetchTemplate()
    },
    fetchTemplate () {
      this.msg = ''
      fetch('biding/template').then(res => {
        // var path = this.apiPath + res.path
        if (res.status === 'success') {
          this.files = res.files
        } else {
          this.msg = res.msg
        }
      })
    },
    handleSuccess () {
      this.fetchTemplate()
    },
    handleFormatError (file) {
      this.$Notice.warning({
        title: 'The file format is incorrect',
        desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
      })
    },
    handleMaxSize (file) {
      this.$Notice.warning({
        title: 'Exceeding file size limit',
        desc: 'File  ' + file.name + ' is too large, no more than 2M.'
      })
    },
    handleBeforeUpload () {
      const check = this.uploadList.length < 5
      if (!check) {
        this.$Notice.warning({
          title: 'Up to five pictures can be uploaded.'
        })
      }
      return check
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.formula-box .item{position: relative;}
.formula-box .item-close{position: absolute;top: -10px;right:0;display: none;border-radius: 18px;width:18px;height:18px;color:#fff;background: #999;font-size: 12px;text-align: center;line-height: 20px;}
.formula-box .item:hover .item-close{display: block}
</style>
